import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const Text = styled.p`
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  color: ${props => props.theme.colors.text.default};
  margin: 0;
`
